const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin/users/$userId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { pickEnum } from "@/lib/search-params";
import { adminPageTitle } from "@/routes/_app/admin/admin-page-title";
const ADMIN_USER_TABS = ["overview", "taste", "notifications", "offer_audits", "activity", "security", "partner"] as const;
const ADMIN_ACTIVITY_SOURCES = ["page_views", "feed_events", "likes", "comments", "user_follows", "artist_follows"] as const;
type AdminUserTab = (typeof ADMIN_USER_TABS)[number];
type AdminActivitySource = (typeof ADMIN_ACTIVITY_SOURCES)[number];
interface AdminUserDetailSearch {
  activitySource: AdminActivitySource;
  tab: AdminUserTab;
}
export const Route = createFileRoute("/_app/admin/users/$userId/")({
  head: () => ({
    meta: [{
      title: adminPageTitle("User")
    }]
  }),
  validateSearch: (raw: Record<string, unknown>): AdminUserDetailSearch => ({
    activitySource: pickEnum(raw.activitySource, ADMIN_ACTIVITY_SOURCES, "page_views"),
    tab: pickEnum(raw.tab, ADMIN_USER_TABS, "overview")
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});